import { DownloadOutlined, UploadOutlined } from '@ant-design/icons'
import { Button, Form, Upload } from 'antd'
import { useState } from 'react'
import { postImportCommunityExcel } from '../../services/postservice'
import ModalCustom from '../common/Modal/ModalCustom'
import openNotification from '../common/Notification/openNotification '
import styles from './styles.module.scss'
import { imessExcel } from '../../services/imessService'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)

const FormAddExcel = ({ isModalOpen, setIsModalOpen, fetchData }) => {
  const [form] = Form.useForm()
  const [excelfileList, setExcelfileList] = useState([])


  const handleImport = async () => {
    const values = await form.validateFields()
    const formData = new FormData()
    formData.append('excel', values.files.file)

    try {
      const res = await imessExcel(formData)

      setIsModalOpen(false)
      fetchData()
      openNotification('success', 'Import thành công')
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Import không thành công')
    }
  }
  const handleChangeFileExcel = ({ fileList }) => {
    setExcelfileList(fileList)
  }

  const handlePreview = (file) => {
    // Tạo URL tạm thời để download file
    const url = URL.createObjectURL(file.originFileObj)
    const a = document.createElement('a')
    a.href = url
    a.download = file.name || 'download.xlsx' // Tên file khi tải về
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url) // Giải phóng bộ nhớ
  }

  return (
    <ModalCustom
      title="Import file"
      visible={isModalOpen}
      centered
      width={600}
      // className="modal-bond"
      onCancel={() => {
        setIsModalOpen(false)
        form.resetFields()
        setExcelfileList([])
        //   setFileList([])
      }}
      onConfirm={async () => {
        try {
          await form.validateFields() // Kiểm tra validation trước khi tiếp tục
          handleImport() // Nếu hợp lệ thì tiếp tục xử lý
        } catch (error) {
          console.log('Validation failed:', error)
        }
      }}
      confirmText={'Lưu'}
      cancelText="Đóng"
    >
      <Form
        layout="horizontal"
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        // wrapperCol={{ span: 18 }}
        style={{
          marginTop: 10,
          overflow: 'auto',
          overflowX: 'hidden',
          padding: '0px 10px'
        }}
        labelAlign="left"
        onFinish={(value) => handleImport(value)}
        requiredMark={customizeRequiredMark}
      >
        <Form.Item label="Upload file" name="files" className={styles.formItem}>
          <Upload
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            fileList={excelfileList}
            onChange={handleChangeFileExcel}
            beforeUpload={() => false}
            onPreview={handlePreview}
            itemRender={(originNode, file) => (
              <a style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                {originNode}
              </a>
            )}
          >
            {excelfileList?.length <= 0 && (
              <Button icon={<UploadOutlined />}>Upload</Button>
            )}
          </Upload>
        </Form.Item>
        <Form.Item label="Template imess list" name="files" style={{padding: '0px 10px'}}>
          <a href="/template/tmp_imess.xlsx">
            <DownloadOutlined /> tmp_imess.xlsx
          </a>
        </Form.Item>
        {/* <span style={{ fontWeight: 600, color: '#f54545', fontSize: 13 }}>
          *Note: Vui lòng chọn loại BĐS để tải template theo đúng loại BĐS
        </span> */}
      </Form>
    </ModalCustom>
  )
}

export default FormAddExcel
